export interface NavItem {
  icon: string;
  label: string;
  labelTh: string;
  href: string;
}

export const MENU_ITEMS: NavItem[] = [
  { icon: 'HomeIcon', label: 'Dashboard', labelTh: 'แดชบอร์ด', href: '/dashboard' },
  { icon: 'ArrowUpTrayIcon', label: 'Import Data', labelTh: 'นำเข้าข้อมูล', href: '/import' },
  {
    icon: 'SparklesIcon',
    label: 'Diamond Inventory',
    labelTh: 'คลังเพชร',
    href: '/diamond-inventory',
  },
  {
    icon: 'AdjustmentsHorizontalIcon',
    label: 'Inventory Mgmt',
    labelTh: 'จัดการคลัง',
    href: '/inventory-management',
  },
  { icon: 'UserGroupIcon', label: 'CRM', labelTh: 'CRM', href: '/crm' },
  { icon: 'ShoppingCartIcon', label: 'Sales', labelTh: 'ยอดขาย', href: '/sales' },
  {
    icon: 'BoltIcon',
    label: 'Sales Automation',
    labelTh: 'ระบบอัตโนมัติ',
    href: '/sales-automation',
  },
  {
    icon: 'ViewColumnsIcon',
    label: 'Deal Pipeline',
    labelTh: 'ไปป์ไลน์ดีล',
    href: '/deal-pipeline',
  },
  {
    icon: 'ClipboardDocumentCheckIcon',
    label: 'Follow-Up Tasks',
    labelTh: 'งานติดตาม',
    href: '/follow-up-tasks',
  },
  {
    icon: 'PresentationChartBarIcon',
    label: 'Pipeline Analytics',
    labelTh: 'วิเคราะห์ไปป์ไลน์',
    href: '/pipeline-analytics',
  },
  { icon: 'CpuChipIcon', label: 'AI Assistant', labelTh: 'ผู้ช่วย AI', href: '/ai-assistant' },
  { icon: 'DocumentTextIcon', label: 'Purchases', labelTh: 'ซื้อ', href: '/purchases' },
  { icon: 'DocumentDuplicateIcon', label: 'Memos', labelTh: 'บันทึก', href: '/memos' },
  { icon: 'LockClosedIcon', label: 'Holds', labelTh: 'ระงับ', href: '/holds' },
  { icon: 'DocumentCheckIcon', label: 'Certificates', labelTh: 'ใบรับรอง', href: '/certificates' },
  { icon: 'PencilSquareIcon', label: 'Appraisal', labelTh: 'ประเมินราคา', href: '/appraisal' },
  {
    icon: 'ScaleIcon',
    label: 'Quotation Builder',
    labelTh: 'สร้างใบเสนอราคา',
    href: '/quotation-builder',
  },
  {
    icon: 'CalculatorIcon',
    label: 'Rapaport Calculator',
    labelTh: 'เครื่องคิดเลข Rapaport',
    href: '/rapaport-calculator',
  },
  { icon: 'ChartBarIcon', label: 'Analytics', labelTh: 'วิเคราะห์', href: '/analytics' },
  { icon: 'BanknotesIcon', label: 'Accounting', labelTh: 'บัญชี', href: '/accounting' },
  {
    icon: 'ClipboardDocumentListIcon',
    label: 'Compliance',
    labelTh: 'ปฏิบัติตามกฎ',
    href: '/compliance',
  },
  {
    icon: 'DocumentMagnifyingGlassIcon',
    label: 'Audit Log',
    labelTh: 'บันทึกการตรวจสอบ',
    href: '/compliance/audit-log',
  },
  { icon: 'EnvelopeIcon', label: 'Email Box', labelTh: 'กล่องจดหมาย', href: '/email-box' },
  { icon: 'CalendarIcon', label: 'Activity Log', labelTh: 'บันทึกกิจกรรม', href: '/activity-log' },
  {
    icon: 'UsersIcon',
    label: 'User Management',
    labelTh: 'จัดการผู้ใช้',
    href: '/user-management',
  },
  { icon: 'UserCircleIcon', label: 'My Profile', labelTh: 'โปรไฟล์ของฉัน', href: '/profile' },
  {
    icon: 'Cog6ToothIcon',
    label: 'Account Settings',
    labelTh: 'ตั้งค่าบัญชี',
    href: '/account-settings',
  },
  {
    icon: 'CreditCardIcon',
    label: 'My Subscription',
    labelTh: 'การสมัครสมาชิก',
    href: '/subscription',
  },
  { icon: 'BanknotesIcon', label: 'Billing & Plan', labelTh: 'การเรียกเก็บเงิน', href: '/billing' },
  { icon: 'DocumentTextIcon', label: 'Invoices', labelTh: 'ใบแจ้งหนี้', href: '/invoices' },
  { icon: 'CogIcon', label: 'Settings', labelTh: 'การตั้งค่า', href: '/settings' },
];
